import { gql } from '@apollo/client';

export const ORDER_REFERENCE_FIELDS = gql`
    fragment OrderReferenceFields on order_references {
        reference_id
        order_id
        key
        value
        label
        created_at
        last_modified_at
    }
`;
